module.exports = __webpack_public_path__ + "assets/img/fd7e6a785bcdf8b270675becb49d04a9.jpg";